export default "__VITE_ASSET__CJFaS8Kc__"